import { Anchor } from '~src/components/Anchor';
import { useDisplayContext } from '~src/context/DisplayContext';

import norlysLogo from '~shared-assets/images/norlys-logo.png';

import { HeaderButtons, LinksNorlys } from './common';
import { HeaderNorlys, LogoNorlys, LogoSubtitleNorlys, LogoWrapperNorlys } from './style';
import { Props } from './types';

export const CalculatorHeaderNorlys = (props: Props) => {
  const { isMobile } = useDisplayContext();

  const logoStyle = {
    left: isMobile ? '20px' : '60px',
  };

  return (
    <HeaderNorlys>
      <HeaderButtons {...props} textColor='black' />
      <Anchor newTab href='https://norlys.dk/'>
        <LogoWrapperNorlys style={{ display: 'flex', alignItems: 'flex-end', ...logoStyle }}>
          <LogoNorlys src={norlysLogo} />

          <LogoSubtitleNorlys>i samarbejde med Bodil Energi</LogoSubtitleNorlys>
        </LogoWrapperNorlys>
      </Anchor>
      <LinksNorlys />
    </HeaderNorlys>
  );
};
